export default [
  {
    path: '/lms/pfi-application',
    name: 'pfi-application',
    component: () => import('@/views/pages/lms/onboarding/ViewDraft.vue'),
    meta: {
      pageTitle: 'Onboarding PFI',
      hasPermission: 'VIEW_PFI',
      breadcrumb: [
        {
          text: 'LMS',
        },
        {
          text: 'Onboarding PFI',
          active: true,
        },
        {
          text: 'PFI Application',
          active: true,
        },
      ],
    },
  },
  {
    path: '/lms/pfi-onboarding-list',
    name: 'pfi-onboarding-list',
    component: () => import('@/views/pages/lms/onboarding/Index.vue'),
    meta: {
      pageTitle: 'PFIs',
      hasPermission: 'VIEW_PFI_ONBOARDING',
      breadcrumb: [
        {
          text: 'LMS',
        },
        {
          text: 'PFIs',
          active: true,
        },
      ],
    },
  },
  {
    path: '/lms/pfi-onboarding/add',
    name: 'pfi-onboarding-add',
    component: () => import('@/views/pages/lms/onboarding/PfiOnboarding.vue'),
    meta: {
      pageTitle: 'Onboarding PFI',
      requiresAuth: false,
      skipFavorites: true,
      layout: 'full',
      resource: 'Auth',
      breadcrumb: [
        {
          text: 'LMS',
        },
        {
          text: 'Onboarding PFI',
          active: true,
        },
      ],
    },
  },
  {
    path: '/lms/pfi-onboarding/:type/:id?',
    name: 'pfi-onboarding',
    component: () => import('@/views/pages/lms/onboarding/PFIOnboardingEdit.vue'),
    meta: {
      pageTitle: 'Onboarding',
      breadcrumb: [
        {
          text: 'LMS',
        },
        {
          text: 'Onboarding PFI',
          active: true,
        },
      ],
    },
  },
  {
    path: '/lms/loan-application-list',
    name: 'loan-application-list',
    component: () => import('@/views/pages/lms/pfi-lending/lending/Index.vue'),
    meta: {
      pageTitle: 'PFI Lending',
      hasPermission: 'VIEW_PFI_ONBOARDING', // change when available
      breadcrumb: [
        {
          text: 'LMS',
        },
        {
          text: 'Loan Application',
          active: true,
        },
      ],
    },
  },
  {
    path: '/lms/loan-application/:type/:id?',
    name: 'loan-application',
    component: () => import('@/views/pages/lms/pfi-lending/lending/Lending.vue'),
    meta: {
      pageTitle: 'Loan Application',
      hasPermission: 'VIEW_EXTERNAL_LOAN_ACCOUNT',
      breadcrumb: [
        {
          text: 'LMS',
        },
        {
          text: 'PFI Lending',
        },
        {
          text: 'Loan Application',
          active: true,
        },
      ],
    },
  },
  {
    path: '/lms/collateral-management',
    name: 'collateral-management',
    component: () => import('@/views/pages/lms/pfi-lending/CollateralManagement.vue'),
    meta: {
      pageTitle: 'Collateral Management',
      hasPermission: 'VIEW_COLLATERAL_INFORMATION',
      breadcrumb: [
        {
          text: 'LMS',
        },
        {
          text: 'PFI Lending',
        },
        {
          text: 'Collateral Management',
          active: true,
        },
      ],
    },
  },
  {
    path: '/lms/batch-upload-validation',
    name: 'batch-upload-validation',
    component: () => import('@/views/pages/lms/BatchUploadAndValidation.vue'),
    meta: {
      pageTitle: 'Batch Upload Validations',
      hasPermission: 'BATCH_END_BENEFICIARY_UPLOAD',
      breadcrumb: [
        {
          text: 'LMS',
        },
        {
          text: 'Batch Upload Validations',
          active: true,
        },
      ],
    },
  },
  {
    path: '/lms/failed-beneficiaries',
    name: 'failed-beneficiaries',
    component: () => import('@/views/pages/lms/FailedBeneficiaries.vue'),
    meta: {
      pageTitle: 'Failed End Beneficiaries',
      hasPermission: 'MODIFY_END_BENEFICIARY_UPLOAD',
      breadcrumb: [
        {
          text: 'LMS',
        },
        {
          text: 'Failed End Beneficiaries',
          active: true,
        },
      ],
    },
  },
  {
    path: '/lms/successful-beneficiaries',
    name: 'successful-beneficiaries',
    component: () => import('@/views/pages/lms/SuccessfulBeneficiaries.vue'),
    meta: {
      pageTitle: 'Successful End Beneficiaries',
      hasPermission: 'VIEW_END_BENEFICIARY',
      breadcrumb: [
        {
          text: 'LMS',
        },
        {
          text: 'Successful End Beneficiaries',
          active: true,
        },
      ],
    },
  },
]
